export enum ErrorMessage {
  SomethingWrong = 'Something went wrong, please try again in a few minutes.',
  SiteNotAdded = 'An error has occurred! Sites have not been added.',
  QuotaIsUsed = 'The number of licenses has been exceeded! Please contact support for assistance.',
  ButtonColorNotChanged = 'An error has occurred. Button color has not been changed',
  ButtonTypeNotChanged = 'An error has occurred. Button type has not been changed',
  ButtonLocationNotChanged = 'An error has occurred. Button location has not been changed',
  SomethingWrongWithSupport = 'Oops, something went wrong. Please contact the support to resolve this issue.',
  PaymentIsDeclined = 'The payment has been declined! Please contact your bank to allow transaction or try another payment method or card.',
  CouponNotApplied = 'Coupon not applied.',
  InvalidLocationData = 'The data is incorrect in one of the fields: Country, State or ZIP Code. Please update with the correct data, and submit again.',
  InvalidNewPassword = 'Password must contain a minimum of 10 characters including a number, a special character, an uppercase letter, and a lowercase letter.',
  OldPasswordMismatch = 'Please check your current password',
  DontHaveSite = 'Sorry, you don’t have this site. Please add it or log in to the account with this website',
  TeamAccountNotFound = 'Team account not found. Please contact support for assistance.',
  VerifyInfo = 'Please verify your info and re-submit the form.',
}

export enum SuccessMessage {
  SiteAdded = 'Sites have been added',
  Applied = 'Successfully applied',
  ButtonColorChanged = 'Button color has been changed',
  ButtonTypeChanged = 'Button type has been changed',
  LTSButtonChanged = 'Live Translation button has been successfully changed.',
  SiteDeleted = 'Site removed successfully.',
  SiteDeletedWithActiveSub = 'Site removed successfully. Deleting a site does not automatically cancel the active subscription associated with it.',
  TeamGroupCreated = 'New group has been created!',
  TeamMemberRemoved = 'User removed successfully',
  GroupMemberRemoved = 'User removed successfully',
  GroupMembersRemoved = 'Users removed successfully',
  TeamGroupDeleted = 'Group has been deleted!',
  TeamMemberInvited = 'Team member has been invited to the group!',
  TeamMembersInvited = 'Team members have been invited to the group!',
  GroupSitesUpdated = 'List of allowed sites has been updated!',
  GroupInfoUpdated = 'Group updated successfully',
  PermissionsUpdated = 'User permissions successfully updated',
  InviteSent = 'Invitation was sent',
  PhotoRemoved = 'Photo has been successfully removed',
  InvitationResent = 'Invitation resent successfully',
  CardUpdated = 'Card updated successfully',
}
